export const Avatar = ({ initial }: { initial: string }) => (
  <span className="shell__avatar" aria-hidden="true">
    {initial}
  </span>
)
